import React, { useContext, useState } from 'react';
import { MDForm } from '../../metadata/MDForm';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { ModelContext } from '../../metadata/ModelSource';
import { DeclaredComponent } from '../../DynamicComponent';
import { Collapse, Icon } from 'antd';
import {TooltipHint} from '../../metadata/TooltipHint';

const { Panel } = Collapse;
const titleWithTooltip = (formTitle,hintText)=>{
  return <div>
    {formTitle}
    {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
  </div>
}

export function ProtectionDevices({ forms, lineCd, formTitle, panelDescription }) {
  const [activeKey2, setActiveKey2] = useState('0');

  return (
    <div>
      <Collapse
        expandIcon={(props) => {
          const { panelKey, isActive } = props;
          return (
            <Icon
              onClick={() => {
                if (activeKey2 === panelKey) {
                  return setActiveKey2('');
                }
                setActiveKey2(panelKey);
              }}
              type={isActive ? 'down' : 'right'}
            />
          );
        }}
        bordered={false}
        activeKey={activeKey2}
        defaultActiveKey={'0'}
        accordion
        style={{ borderBottom: '0px' }}
      >
        <Panel header={formTitle} className='property-list-form-header'>
          <span>{panelDescription}</span>
          <AlarmsSecurity {...forms['AlarmsSecurity']} lineCd={lineCd} />
          <MonitoringDetection {...forms['MonitoringDetection']} lineCd={lineCd} />
        </Panel>
      </Collapse>
    </div>
  );
}


export function AlarmsSecurity({ form, lineCd, formTitle, className, hintText}) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);
  const [activeKey2, setActiveKey2] = useState('0');

  const lineProductSetupContext =
    productSetup.productSubTypes.productSubType[0].productLine[0]
      .productRiskTypes.productRiskType[0];
  return (
    <div>
      <Collapse
        expandIcon={(props) => {
          const { panelKey, isActive } = props;
          return (
            <Icon
              onClick={() => {
                if (activeKey2 === panelKey) {
                  return setActiveKey2('');
                }
                setActiveKey2(panelKey);
              }}
              type={isActive ? 'down' : 'right'}
            />
          );
        }}
        bordered={false}
        activeKey={activeKey2}
        defaultActiveKey={'0'}
        accordion
        style={{ borderBottom: '0px' }}
      >
        <Panel header={titleWithTooltip(formTitle,hintText)} className='alarm-security-form-header'>
          <MDForm
            prefix={`lines{lineCd:${lineCd}}.risks[0]`}
            model={applicationModel}
            productSetupContext={lineProductSetupContext}
            presentationMetadata={form}
          >
          <DeclaredComponent declaration={form} />
        </MDForm>
        </Panel>
      </Collapse>
    </div>
  );
}

export function MonitoringDetection({ form, lineCd, formTitle, hintText }) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);
  const [activeKey2, setActiveKey2] = useState('0');

  const lineProductSetupContext =
    productSetup.productSubTypes.productSubType[0].productLine[0]
      .productRiskTypes.productRiskType[0];
 
  return (
    <div>
      <Collapse
        expandIcon={(props) => {
          const { panelKey, isActive } = props;
          return (
            <Icon
              onClick={() => {
                if (activeKey2 === panelKey) {
                  return setActiveKey2('');
                }
                setActiveKey2(panelKey);
              }}
              type={isActive ? 'down' : 'right'}
            />
          );
        }}
        bordered={false}
        activeKey={activeKey2}
        defaultActiveKey={'0'}
        accordion
        style={{ borderBottom: '0px' }}
      >
        <Panel header={titleWithTooltip(formTitle,hintText)} className='alarm-security-form-header'>
        <MDForm
            prefix={`lines{lineCd:${lineCd}}.risks[0]`}
            model={applicationModel}
            productSetupContext={lineProductSetupContext}
            presentationMetadata={form}
          >
          <DeclaredComponent declaration={form} />
        </MDForm>
        </Panel>
      </Collapse>
    </div>
  );
}